import React from "react";

// ─────────────────────────────────────────────
// PLATFORM PILL
// ─────────────────────────────────────────────
export const PlatformPill = ({ icon, color, label, value }) => {
  const styles = {
    blue: "bg-blue-50 text-blue-600",
    purple: "bg-purple-50 text-purple-600",
    green: "bg-green-50 text-green-600",
  };
  return (
    <div className={`flex items-center gap-2 px-4 py-2 rounded-xl border border-gray-100 ${styles[color]} bg-opacity-60`}>
      <i className={`fa-solid ${icon} text-sm`} />
      <div>
        <p className="text-[10px] font-bold uppercase tracking-wide opacity-70">{label}</p>
        <p className="text-base font-bold leading-tight">{value}</p>
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────
// PLATFORM TOPIC ROW
// ─────────────────────────────────────────────
export const PlatformTopicRow = ({ rank, item, maxCount }) => {
  const barWidth = Math.max(4, Math.round((item.reviewerCount / maxCount) * 100));
  const rankColors = ["text-yellow-500", "text-gray-400", "text-orange-400"];
  const rankColor = rank <= 3 ? rankColors[rank - 1] : "text-gray-300";

  return (
    <div className="grid grid-cols-12 items-center gap-1 px-3 py-2.5 rounded-xl hover:bg-gray-50 transition group">
      {/* Rank */}
      <span className={`col-span-1 text-sm font-bold ${rankColor}`}>
        {rank <= 3 ? <i className="fa-solid fa-trophy text-xs" /> : rank}
      </span>

      {/* Topic + bar */}
      <div className="col-span-4">
        <p className="text-sm font-bold text-gray-800 truncate" title={item.topic}>{item.topic}</p>
        <div className="mt-1 h-1 bg-gray-100 rounded-full overflow-hidden">
          <div
            className="h-full bg-indigo-400 rounded-full transition-all duration-700"
            style={{ width: `${barWidth}%` }}
          />
        </div>
      </div>

      {/* Reviewer count */}
      <div className="col-span-3 text-center">
        <span className="text-sm font-bold text-indigo-600">{item.reviewerCount.toLocaleString()}</span>
        <p className="text-[10px] text-gray-400">reviewers</p>
      </div>

      {/* Student count */}
      <div className="col-span-2 text-center">
        <span className="text-sm font-bold text-purple-600">{item.studentCount.toLocaleString()}</span>
        <p className="text-[10px] text-gray-400">students</p>
      </div>

      {/* Quiz count */}
      <div className="col-span-2 text-center">
        <span className="text-sm font-bold text-green-600">{item.quizCount.toLocaleString()}</span>
        <p className="text-[10px] text-gray-400">quizzes</p>
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────
// TREND BAR (monthly creation chart)
// ─────────────────────────────────────────────
export const TrendBar = ({ month, count, maxCount }) => {
  const heightPct = Math.max(6, Math.round((count / maxCount) * 100));
  return (
    <div className="flex-1 flex flex-col items-center justify-end gap-1 group cursor-default">
      <span className="text-[10px] font-bold text-indigo-600 transition">{count}</span>
      <div
        className="w-full bg-indigo-400 rounded-t-md group-hover:bg-indigo-500 transition-all duration-500"
        style={{ height: `${heightPct}%` }}
      />
      <span className="text-[10px] text-gray-400 text-center leading-tight whitespace-nowrap">{month}</span>
    </div>
  );
};
